<template>
  <div class="home">
    <div class="model-wrap">
      <!-- src="https://webshare.shanhaibi.com/uw8r8rfxdlga/" -->

      <!-- <iframe src="http://192.168.65.202:6080/vnc.html" frameborder="0" id="iframeBox"></iframe> -->
      <iframe :src="BASE_URL_VNC" frameborder="0" id="iframeBox" v-if="iframeVisible"></iframe>
    </div>
    <top-bar />
    <div class="side_box">
      <!-- 电站总览 -->
      <LeftBoxOne v-if="globalTab == '电站总览'"></LeftBoxOne>
      <RightBoxOne v-if="globalTab == '电站总览'"></RightBoxOne>
      <TabSide v-if="globalTab == '电站总览'" :curTab="globalTab"></TabSide>
      <TabSideBridge v-if="globalTab == '演示'"></TabSideBridge>
      <WaterPosition :position="curWaterPosition" v-if="globalTab == '电站总览'"></WaterPosition>

      <!-- 故障诊断 -->
      <LeftBoxTwo v-if="globalTab == '故障诊断'"></LeftBoxTwo>
      <RightBoxTwo v-if="globalTab == '故障诊断'"></RightBoxTwo>

      <!-- 智能巡检 -->
      <LeftBoxThree v-if="globalTab == '智能巡检'"></LeftBoxThree>
      <RightBoxThree v-if="globalTab == '智能巡检'"></RightBoxThree>

      <!-- 预警预演 -->
      <LeftBoxFour v-if="globalTab == '预警预演'"></LeftBoxFour>
      <RightBoxFour v-if="globalTab == '预警预演'"></RightBoxFour>

      <TabBottom></TabBottom>
    </div>
    <div class="footer_line"></div>
    <ModalVideo v-if="showVideoModal" :videoSrc="curVideoSrc"></ModalVideo>
  </div>
</template>

<script>
import TopBar from '@/components/TopBar/index.vue';
import LeftBoxOne from '@/views/PowerOverView/LeftBox.vue';
import RightBoxOne from '@/views/PowerOverView/RightBox.vue';
import LeftBoxTwo from '@/views/PowerFaultDiagnosic/LeftBox.vue';
import RightBoxTwo from '@/views/PowerFaultDiagnosic/RightBox.vue';
import LeftBoxThree from '@/views/PowerSmartCheck/LeftBox.vue';
import RightBoxThree from '@/views/PowerSmartCheck/RightBox.vue';
import LeftBoxFour from '@/views/PowerVisit/LeftBox.vue';
import RightBoxFour from '@/views/PowerVisit/RightBox.vue';

import TabSide from '@/components/TabSide.vue';
import TabSideBridge from '@/components/TabSideBridge.vue';
import TabBottom from '@/components/TabBottom.vue';
import WaterPosition from '@/components/WaterPosition.vue';
import ModalVideo from '@/views/PowerOverView/ModalVideo.vue';
import { BASE_URL_VNC, VideoMap, BASE_IP_URL } from '@/globalConfig';

import * as Api from '@/api';
export default {
  name: 'Home',
  components: {
    TopBar,
    LeftBoxOne,
    RightBoxOne,
    TabSide,
    TabSideBridge,
    TabBottom,
    WaterPosition,
    ModalVideo,
    LeftBoxTwo,
    RightBoxTwo,
    LeftBoxThree,
    RightBoxThree,
    LeftBoxFour,
    RightBoxFour,
  },
  data() {
    return {
      showVideoModal: false,
      globalTab: '电站总览', //默认
      BASE_URL_VNC,
      curVideoSrc: '',
      curWaterPosition: 500,
      iframeVisible: true,
      curVideoList: [],
    };
  },
  computed: {},
  mounted() {
    // 如果是本地开发就不显示iframe 避免卡顿
    // this.iframeVisible = !window.location.href.includes('100.231');
    // this.iframeVisible = !window.location.href.includes('192.168');
    // this.getStationWarnsApi();
    this.getInitData();

    // 点击页面视频框传过来的视频链接
    this.$bus.$on('curVideoSrc', (data) => {
      this.curVideoSrc = data;
    });

    // 点击模型上的监控点传过来的视频code
    this.$bus.$on('curVideoModalCode', (data) => {
      this.curVideoList = this.$Storage.get('videoListStorage') || null;
      const { id } = VideoMap[data];
      console.log('curVideoItem', this.curVideoList);
      const curVideoItem = this.curVideoList.filter((item) => {
        return item.id == id;
      });
      console.log('curVideoItem', curVideoItem);
      this.curVideoSrc = curVideoItem[0].liveSourceAddress.replace(
        'http://223.214.6.181:8950/openUrl/',
        // '172.30.100.204:8950'
        BASE_IP_URL
      );
      console.log('curVideoSrc :>> ', this.curVideoSrc);
    });
    this.$bus.$on('showVideoModal', (data) => {
      this.showVideoModal = data;
      console.log('data :>> ', data);
    });
    this.$bus.$on('globalTab', (data) => {
      this.globalTab = data;
    });
    // Object.keys(Api).forEach(function (key) {
    //   Api[key]();
    // });
    // Api.getDamRealData();
  },
  methods: {
    getInitData() {
      // 获取大坝水位水库水位
      Api.getRealData({ deviceCode: 'RR50705074_ZC' }).then((res) => {
        console.log('dabasuhiwei :>> ', res);
        if (res.success) {
          const dealData = Number(res.data[0].value).toFixed(2).toString();
          this.curWaterPosition = dealData;
          this.$Storage.set('curWaterPosition', this.curWaterPosition);

          // this.curWaterPosition = 531;
        }
      });

      // 获取大坝预演数据
      Api.getPreviewSchemeContent().then((res) => {
        console.log('res :>> ', res);
        this.$Storage.set('previewSchemeData', res.data);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// el-table属性-----开始
::v-deep .card_table {
  border: 1px solid rgba(36, 87, 130, 0.52) !important;
}
::v-deep .el-form-item {
}
::v-deep .el-table,
.el-table__expanded-cell {
  background-color: transparent !important;
}
::v-deep .el-table th {
  background-color: rgba(3, 74, 144, 0.3) !important;
  border-top: 1px solid;
  border-color: rgba(36, 87, 130, 0.52);
}
::v-deep .el-table tr {
  background-color: transparent !important;
  &.current-row {
    background-color: #093561 !important;
  }
}

::v-deep .el-table--enable-row-transition .el-table__body td,
::v-deep .el-table .cell {
  background-color: transparent !important;
  color: rgba(190, 225, 249, 0.8) !important;
  border-color: rgba(36, 87, 130, 0.52);
  white-space: nowrap;
  cursor: pointer;
  font-size: 18px;
  font-weight: 600;
}
::v-deep .el-table th > .cell {
  color: rgba(190, 225, 249, 0.8) !important;
  font-weight: 700 !important;
}
::v-deep .el-table td.el-table__cell,
::v-deep .el-table th.el-table__cell.is-leaf {
  border: none !important;
}
::v-deep .el-table::before {
  //去除底部白线
  left: 0 !important;
  bottom: 0 !important;
  width: 100% !important;
  height: 0 !important;
}

::v-deep .el-form-item__label {
  color: white !important;
}
// el-table属性-----结束
.home {
  // transform: translateX(-50%);
  width: 100%;
  height: 100vh;
  background-color: #0b1f37;
  position: relative;
  overflow: hidden;
  .side_box {
    display: flex;
    justify-content: space-between;
    // padding: 32px 40px;
    height: calc(100% - 67px);
    // margin-top: -13px;
  }
  .footer_line {
    width: 3200px;
    height: 24px;
    background: url('../assets/hs/img底部.png') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    bottom: -18px;
  }
  .model-wrap {
    // position: absolute;
    // top: 0;
    width: 100%;
    height: 100%;

    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    // width: 2560px;
    // height: 1740px;
    margin: auto;
    // transform: scale(1.6);
    #iframeBox {
      // width: 100%;
      // height: 100%;
      // 以下是现场部署使用
      width: 2560px;
      height: 1440px;
      // width: 1920px;
      // height: 1080px;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      transform: scale(1.4);
    }
  }
}
</style>
